import cn from 'classnames';
import { CSSProperties } from 'react';
import { DESK_ICONS, DeskIconName } from './icons';
import './styles.scss';

interface Props {
  name: DeskIconName;
  /** px; 20 in the shell, 16 in buttons, 13 in tags */
  size?: number;
  className?: string;
  style?: CSSProperties;
  /** an accessible name; without it the glyph is decorative */
  title?: string;
}

/**
 * A glyph of the design system, painted on currentColor.
 *
 * @param props - the glyph's name, size and an optional accessible title
 * @returns the inline SVG in a sized span
 */
const DeskIcon = ({ name, size = 20, className, style, title }: Props) => (
  <span
    className={cn('desk-icon', className)}
    role={title ? 'img' : undefined}
    aria-label={title}
    aria-hidden={title ? undefined : true}
    style={{ width: size, height: size, ...style }}
    // static markup from the design system's own glyph set, never user input
    dangerouslySetInnerHTML={{ __html: DESK_ICONS[name] }}
  />
);

export default DeskIcon;
